module.exports = __webpack_public_path__ + "assets/img/synchronization.b2224f57.png";